import { render, staticRenderFns } from "./pricing-plan-radio.vue?vue&type=template&id=40f62677&"
import script from "./pricing-plan-radio.vue?vue&type=script&lang=js&"
export * from "./pricing-plan-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports